mutation UpdateCharityCategory(
  $charityCategoryId: ID!
  $charityCategoryInput: CharityCategoryChangeInput!
) {
  updateCharityCategory(
    input: {
      charityCategoryId: $charityCategoryId
      charityCategoryInput: $charityCategoryInput
    }
  ) {
    charityCategory {
      id
    }
  }
}
